import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getUtility } from '@livable/saas-react-components';
import { TableCell, TableRow, Typography, Chip, Button } from '@mui/material';
import { observer } from 'mobx-react-lite';
import moment from 'moment';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { billStatuses } from 'src/constants/utilities';
import { useStore } from 'src/stores';
import useStyles from '../../AllocationProgress/styles';
import { SubmeterBillModal } from 'src/pages/NewBillingModule/SubmeterBillModal';
const AllocationFromHistoryRow = observer(_ref => {
  var _store$utilityProvide;
  let utility = _ref.utility,
    subMeterFinalState = _ref.subMeterFinalState,
    propertyData = _ref.propertyData,
    cycleName = _ref.cycleName;
  const classes = useStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const notSet = t('allocations.not_set');
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpenSubModal = _useState2[0],
    setIsOpenSubModal = _useState2[1];
  const billStatus = utility.billStatus,
    billValue = utility.billValue,
    commonAreaDeduction = utility.commonAreaDeduction,
    goodwillDeduction = utility.goodwillDeduction,
    rationBilled = utility.rationBilled,
    serviceEndDateOnly = utility.serviceEndDateOnly,
    serviceStartDateOnly = utility.serviceStartDateOnly,
    total = utility.total;
  const statuses = billStatuses(t);
  const utilityData = getUtility((_store$utilityProvide = store.utilityProviders.utilities.get(utility.utilityId)) === null || _store$utilityProvide === void 0 ? void 0 : _store$utilityProvide.utilityTypeName);
  const getChip = status => {
    const s = status || 'PendingCompletion';
    return /*#__PURE__*/React.createElement(Chip, {
      label: statuses[s].label,
      variant: statuses[s].variant
    });
  };
  const getDate = date => date ? moment(date).format('L') : notSet;
  const getValue = value => {
    if (value && value >= 0) {
      return value + '%';
    } else {
      return notSet;
    }
  };
  return /*#__PURE__*/React.createElement(TableRow, null, /*#__PURE__*/React.createElement(TableCell, null, /*#__PURE__*/React.createElement("div", {
    className: classes.utility
  }, utilityData.icon(), /*#__PURE__*/React.createElement(Typography, {
    variant: "h5",
    className: classes.siblingText
  }, utilityData.title), !!(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && '\n (Submetered)')), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && getDate(serviceStartDateOnly)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && getDate(serviceEndDateOnly)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && (billValue ? "$".concat(billValue) : notSet)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && "".concat(commonAreaDeduction || 0, "%")), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && getValue(goodwillDeduction)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && "$".concat(rationBilled || 0)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, !!(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) ? /*#__PURE__*/React.createElement(Button, {
    variant: "actionButton",
    onClick: () => setIsOpenSubModal(true),
    'custom-attribute': '641-new-billing-module'
  }, /*#__PURE__*/React.createElement("span", {
    className: "actionText"
  }, "Preview")) : "$".concat(total || 0)), /*#__PURE__*/React.createElement(TableCell, {
    align: "right"
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !!(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) && /*#__PURE__*/React.createElement(SubmeterBillModal, {
    submeterFinalStateInfo: subMeterFinalState,
    isOpen: isOpenSubModal,
    handleChangeIsOpen: v => setIsOpenSubModal(v),
    propertyAddress: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyAddress,
    propertyId: propertyData === null || propertyData === void 0 ? void 0 : propertyData.propertyId,
    utilityName: utilityData.title,
    cycleName: cycleName,
    status: 'TableReadyStatementSent',
    allocationMethod: 'By submeter',
    isPreviewOnly: true
  }), getChip(!!subMeterFinalState && !!(subMeterFinalState !== null && subMeterFinalState !== void 0 && subMeterFinalState.length) ? 'SubmeterChargesSent' : billStatus))));
});
export default AllocationFromHistoryRow;